import { extend } from 'vee-validate'
import { required, email, alpha, numeric, included, min_value, max_value, alpha_spaces, confirmed, alpha_num, ext, size, length, between } from 'vee-validate/dist/rules';

extend('positive', value => { return value > 0 },);

extend('max_value', {
  ...max_value,
  message: 'El valor debe ser menor o igual a {max}.',
  params: ['max']
});
extend('max_value_plan', {
  ...max_value,
  message: 'Tu deuda sólo se puede financiar hasta en {max} cuotas.',
  params: ['max']
});
extend('required_plan', {
  ...required,
  message: 'Tu deuda sólo se puede financiar hasta en {max} cuotas.',
  params: ['max']
});
extend('between', {
  ...between,
  message: 'El campo debe estar entre {min} y {max}.',
  params: ['min', 'max']
});
extend('min_value', {
  ...min_value,
  message: 'El valor debe ser mayor a {min}.',
  params: ['min']
});
extend('length', {
  ...length,
  message: 'El campo debe tener {length} caracteres.',
});
extend('length_tarjeta', {
  ...length,
  message: 'Formato incorrecto. El número de tarjeta debe tener 16 dígitos.',
});
extend('alpha_spaces', {
  validate(value) {
    // Permitir letras, espacios y los caracteres "'", "´" y "`"
    const regex = /^[A-Za-zÁÉÍÓÚÜÑáéíóúüñ\s'´`]+$/;
    return regex.test(value);
  },
  message: 'Formato invalido.',
});

extend('alphanumeric_strict', {
  validate(value) {
    // Solo permitir letras de a-z, A-Z, números 0-9, incluyendo ñ, Ñ y tildes áéíóúÁÉÍÓÚüÜ
    const regex = /^[A-Za-z0-9ÁÉÍÓÚÜÑáéíóúüñ\s]+$/;
    return regex.test(value);
  },
  message: 'Formato invalido.',
});

extend('min', {
  validate(value, args) {
    return value.length >= args.length;
  },
  message: 'Formato incorrecto.',
  params: ['length']
});
extend('max', {
  validate(value, args) {
    return value.length <= args.length;
  },
  message: 'Alcanzaste la capacidad maxima del campo.',
  params: ['length']
});
extend("nofechafutura", {
  validate(value) {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Ajusta las horas a las 00:00:00

    const selectedDate = new Date(value);
    selectedDate.setHours(0, 0, 0, 0); // Asegura que la comparación sea solo por fecha

    const defaultDate = new Date('1900-01-01');
    defaultDate.setHours(0, 0, 0, 0); // Ajusta la fecha por defecto a las 00:00:00
    // Verifica que la fecha seleccionada sea mayor a hoy
    return (selectedDate.getTime() < today.getTime() && selectedDate.getTime() !== defaultDate.getTime());
  },
  message: "La fecha no es valida.",
});
extend("fechafutura", {
  validate(value) {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1); // Resta un día para obtener la fecha de ayer
    yesterday.setHours(0, 0, 0, 0); // Ajusta las horas a las 00:00:00

    const selectedDate = new Date(value);
    selectedDate.setHours(0, 0, 0, 0); // Asegura que la comparación sea solo por fecha

    // Verifica que la fecha seleccionada sea mayor a ayer
    return (selectedDate.getTime() >= yesterday.getTime());
  },
  message: "La fecha debe ser mayor o igual a la fecha de hoy.",
});
extend("menordosanios", {
  validate(value) {
    const today = new Date();
    const selectedDate = new Date(value);

    const minDate = new Date();
    minDate.setFullYear(today.getFullYear() - 2);

    // Verifica que la fecha seleccionada esté dentro del rango y no sea futura
    return selectedDate >= minDate && selectedDate <= today;
  },
  message: "La fecha no es valida.",
});
extend("menoranios", {
  params: ["years"],
  validate(value, { years }) {
    const today = new Date();
    const selectedDate = new Date(value);

    // Calcula la fecha límite superior (18 años atrás) y la inferior (100 años atrás)
    const maxDate = new Date();
    maxDate.setFullYear(today.getFullYear() - 18);

    const minDate = new Date();
    minDate.setFullYear(today.getFullYear() - 100);

    // Verifica que la fecha seleccionada esté dentro del rango y no sea futura
    return selectedDate >= minDate && selectedDate <= maxDate && selectedDate <= today;
  },
  message: "La fecha no es valida.",
});
extend("menorDeEdad", {
  validate(value) {
    const today = new Date();
    const selectedDate = new Date(value);

    // Calcula la fecha límite superior (menos de 18 años desde hoy)
    const minAgeDate = new Date();
    minAgeDate.setFullYear(today.getFullYear() - 18);

    // Verifica que la fecha seleccionada sea posterior a la fecha límite de 18 años y no sea futura
    return selectedDate > minAgeDate && selectedDate <= today;
  },
  message: "Debe ser menor de 18 años.",
});
extend("rangoFechas", {
  params: ["fechaDada", "customMessage"], // Parámetros para la fecha mínima y el mensaje personalizado
  validate(value, { fechaDada }) {
    // Parseo timezone-safe que acepta ISO 'yyyy-mm-dd' o 'dd/mm/yyyy'. Evita el drift de
    // new Date(isoString), que interpreta la fecha como UTC y, al pasarla a hora local
    // (UTC-3), la corre un dia hacia atras.
    const parse = (v) => {
      if (!v) return null;
      const s = String(v);
      let y, m, d;
      if (s.indexOf('-') !== -1) { [y, m, d] = s.split('-'); }        // ISO yyyy-mm-dd
      else if (s.indexOf('/') !== -1) { [d, m, y] = s.split('/'); }   // dd/mm/yyyy
      else { return null; }
      return new Date(Number(y), Number(m) - 1, Number(d));
    };

    const selectedDate = parse(value);
    if (!selectedDate) return true;   // vacio o no parseable: lo maneja la regla 'required'

    const minDate = parse(fechaDada);
    if (!minDate) return true;         // sin fecha minima (ej. fectit vacio): nada que comparar

    selectedDate.setHours(0, 0, 0, 0);
    minDate.setHours(0, 0, 0, 0);

    // Debe ser posterior o igual a la fecha minima. El "no futura" lo garantiza el
    // :max del date-picker en la UI (y debe validarlo el backend para el caso curl).
    return selectedDate.getTime() >= minDate.getTime();
  },
  methods: {
    formatDate(date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
  },
  message: (field, { customMessage, fechaDada }) =>
    customMessage || `La fecha debe ser posterior a ${fechaDada.split('-').reverse().join('/')}.`,
});

extend("rangoFechasAnterior", {
  params: ["fechaDada", "customMessage"], // Parámetros para la fecha máxima y el mensaje personalizado
  validate(value, { fechaDada }) {
    // Parseo timezone-safe que acepta ISO 'yyyy-mm-dd' o 'dd/mm/yyyy' (mismo criterio que rangoFechas).
    const parse = (v) => {
      if (!v) return null;
      const s = String(v);
      let y, m, d;
      if (s.indexOf('-') !== -1) { [y, m, d] = s.split('-'); }        // ISO yyyy-mm-dd
      else if (s.indexOf('/') !== -1) { [d, m, y] = s.split('/'); }   // dd/mm/yyyy
      else { return null; }
      return new Date(Number(y), Number(m) - 1, Number(d));
    };

    const selectedDate = parse(value);
    if (!selectedDate) return true;   // vacio: lo maneja la regla 'required'

    const maxDate = parse(fechaDada);
    if (!maxDate) return true;         // sin fecha maxima: nada que comparar

    selectedDate.setHours(0, 0, 0, 0);
    maxDate.setHours(0, 0, 0, 0);

    // Debe ser anterior o igual a la fecha maxima.
    return selectedDate.getTime() <= maxDate.getTime();
  },
  methods: {
    formatDate(date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
  },
  message: (field, { customMessage, fechaDada }) =>
    customMessage || `La fecha debe ser anterior o igual a ${fechaDada.split('-').reverse().join('/')}.`,
});


extend('minmax', {
  validate(value, { min, max }) {
    return value.length >= min && value.length <= max;
  },
  message: 'Debe tener entre {min} y {max} caracteres',
  params: ['min', 'max'],
});
extend('alpha', {
  ...alpha,
  message: 'Formato incorrecto.'
});
extend('alpha_num', {
  ...alpha_num,
  message: 'El campo debe contener letras y números.'
});
extend('alpha_spaces', {
  ...alpha_spaces,
  message: 'Formato incorrecto.'
});
extend('ext', {
  ...ext,
  message: 'Formato(s) de archivo(s) incorrecto(s).'
});
extend('size', {
  ...size,
  message: 'Archivo(s) alcanzaron el maximo permitido'
});
extend('required', {
  ...required,
  message: 'Campo requerido.'
});

extend('email', {
  ...email,
  message: 'Email invalido.'
});
extend('numeric', {
  ...numeric,
  message: 'Formato incorrecto.'
});
extend('confirmed', {
  ...confirmed,
  message: 'No hay coincidencia en los campos.'
});
extend("validCuil", {
  params: ["dni"], // Acepta un parámetro para comparar con el DNI
  validate(value, { dni }) {
    const cuilRegex = /^(\d{2})(\d{8})(\d{1})$/;

    // Verificar formato general
    if (!cuilRegex.test(value)) {
      return false;
    }

    const match = value.match(cuilRegex);
    const dniFromCuil = match[2]; // Extraer el DNI del CUIL

    // Verificar si el DNI en el CUIL coincide con el campo DNI
    return dniFromCuil === dni;
  },
  message: "El CUIL debe ser válido y contener el DNI especificado.",
});
extend("validPhone", {
  params: ["caracteristica"], // Recibe la característica como parámetro
  validate(value, { caracteristica }) {
    // Verificar que la característica sea de 3 o 4 dígitos
    const caracteristicaRegex = /^\d{2,4}$/;
    if (!caracteristicaRegex.test(caracteristica)) {
      return false; // Si la característica no es válida, el número no será válido
    }

    // Calcular la cantidad de dígitos que debería tener el teléfono
    const expectedPhoneLength = 10 - caracteristica.length;

    // Verificar que el teléfono tenga la cantidad esperada de dígitos
    const phoneRegex = new RegExp(`^\\d{${expectedPhoneLength}}$`);
    return phoneRegex.test(value); // Retorna true si el teléfono tiene la longitud esperada
  },
  message: "El número telefónico debe ser válido y su longitud debe sumar 10 dígitos con la característica.",
});
extend('password_strong', {
  validate(value) {
    // Al menos 8 caracteres y al menos una mayúscula
    return /^(?=.*[A-Z]).{8,}$/.test(value);
  },
  message: 'La contraseña debe tener 8 caracteres o más y al menos una letra mayúscula.'
});

// Validación de vencimiento MM/AA posterior al mes y año actual
extend('exp_mm_aa', {
  validate(value) {
    if (!value) return false;
    const match = /^(0[1-9]|1[0-2])\/(\d{2})$/.exec(value);
    if (!match) return false;
    const mm = parseInt(match[1], 10);
    const yy = parseInt(match[2], 10); // últimos 2 dígitos
    const now = new Date();
    const currMonth = now.getMonth() + 1; // 1-12
    const currYear2 = now.getFullYear() % 100; // últimos 2 dígitos
    // Debe ser estrictamente posterior al mes/año actual
    if (yy > currYear2) return true;
    if (yy === currYear2 && mm > currMonth) return true;
    return false;
  },
  message: 'La fecha debe ser posterior al mes y año actual (MM/AA).'
});

// Validación de tarjeta Visa con algoritmo Luhn
extend('visa_luhn', {
  validate(value) {
    if (!value) return false;

    // Remover espacios y caracteres no numéricos
    const cardNumber = value.replace(/\D/g, '');

    // Verificar que sea Visa (comienza con 4)
    if (!cardNumber.startsWith('4')) {
      return false;
    }

    // Verificar longitud (Visa: 13, 16 o 19 dígitos)
    if (![13, 16, 19].includes(cardNumber.length)) {
      return false;
    }

    // Algoritmo Luhn
    let sum = 0;
    let alternate = false;

    for (let i = cardNumber.length - 1; i >= 0; i--) {
      let n = parseInt(cardNumber[i]);

      if (alternate) {
        n *= 2;
        if (n > 9) {
          n = (n % 10) + 1;
        }
      }

      sum += n;
      alternate = !alternate;
    }

    return (sum % 10) === 0;
  },
  message: 'El número de tarjeta Visa no es válido.',
});

// Validación para número de documento mayor a 2,000,000
extend('min_doc', {
  validate(value) {
    if (!value) return false;
    const numericValue = parseInt(value);
    return numericValue > 2000000;
  },
  message: 'El número de documento es incorrecto.',
});



